<template>
  <div class="slides__content">
    <div class="grid">
      <div class="grid__column--six">
        <div class="form__group">
          <label class="form__label" for="title">Title:</label>
          <input type="text" name="title" v-model="activeSlide.title"/>
        </div>
        <div class="form__group">
          <label class="form__label" for="sub_title">Sub title:</label>
          <input type="text" name="sub_title" v-model="activeSlide.sub_title"/>
        </div>
        <div class="form__group">
          <label class="form__label" for="sub_title">Link:</label>
          <input type="text" name="sub_title" v-model="activeSlide.link"/>
        </div>
        <div class="formToggle">
          <input class="formToggle__checkbox" type="checkbox" name="toggle" id="toggle" v-model="activeSlide.link_new_tab">
          <label class="formToggle__label formToggle__label--large" for="toggle"><span>ON/OFF</span> Open link in new tab</label>
        </div>
        <div class="form__group">
          <label class="form__label" for="description">Description:</label>
          <textarea type="text" name="description" v-model="activeSlide.description"/>
        </div>

        <div class="form__group">
          <button type="button" class="btn btn--primary mt1" v-if="activeSlide.id" @click="submitSlide">UPDATE SLIDE</button>
          <button type="button" class="btn btn--primary mt1" v-else @click="submitSlide">PUBLISH</button>

          <button type="button" class="btn btn--danger mt1" v-if="activeSlide.id" v-on:click="$emit('deleteSlide')">DELETE</button>
        </div>
      </div>
      <div class="grid__column--six">
        <div class="form__group">
          <UploadImage :image.sync="activeSlide.media"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from '@/components/Utils/UploadImage'
import Slide from '@/model/Slide'
import displayError from '@/helpers/displayError'

export default {
  components: {
    UploadImage
  },
  props: {
    activeSlide: {
      type: Object,
      defulat: {}
    },
    slides: {
      type: Array,
      defulat: []
    },
    setActive: {
      type: Function
    }
  },
  methods: {
    submitSlide () {
      if (this.activeSlide.id) {
        let allPromieses = []

        this.slides.forEach((slide) => {
          slide['order'] = this.slides.indexOf(slide) + 1
          allPromieses.push(Slide.update(this.$route.params.id, slide))
        })

        axios.all(allPromieses).then(axios.spread(() => {
          this.$snotify.success('Successfully updated.')
        }))
      } else {
        this.activeSlide.order = this.slides.indexOf(this.activeSlide) + 1
        Slide.create(this.$route.params.id, this.activeSlide).then((response) => {
          this.activeSlide = response.data.data
        }).catch((error) => {
          displayError(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Slider/Slide.vue